import * as React from "react";
import { Button, FormControl, InputGroup, ListGroup, ListGroupItem, } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { setGameSearchPaths } from "../../../actions";
import Icon from "../../../controls/Icon";
import Modal from "../../../controls/Modal";
import { IconButton } from "../../../controls/TooltipControls";
function GameSelectionDialog(props) {
    const { t, onHide, onScan, onSelectPath, onSetSearchPaths, searchPaths, visible, } = props;
    const [paths, setPaths] = React.useState(searchPaths);
    const addSearchPath = React.useCallback(() => {
        setPaths([].concat(paths, process.platform === "win32" ? "C:" : "/"));
    }, [paths, setPaths]);
    const updateSearchPath = React.useCallback((idx, newPath) => {
        const temp = paths.slice();
        temp.splice(idx, 1, newPath);
        setPaths(temp);
    }, [paths, setPaths]);
    const removeSearchPath = React.useCallback((remPath) => {
        setPaths(paths.filter((iter) => iter !== remPath));
    }, [paths, setPaths]);
    const scan = React.useCallback(() => {
        onSetSearchPaths(paths);
        onScan(paths);
        onHide();
    }, [paths, onSetSearchPaths, onScan]);
    return (React.createElement(Modal, { show: visible, onHide: nop },
        React.createElement(Modal.Header, null,
            React.createElement(Modal.Title, null, t("Select directories to scan"))),
        React.createElement(Modal.Body, null,
            React.createElement(PathsList, { t: t, onAddSearchPath: addSearchPath, onUpdateSearchPath: updateSearchPath, onRemoveSearchPath: removeSearchPath, onSelectPath: onSelectPath, paths: paths })),
        React.createElement(Modal.Footer, null,
            React.createElement(Button, { onClick: onHide }, t("Cancel")),
            React.createElement(Button, { onClick: scan }, t("Scan")))));
}
function mapStateToProps(state) {
    return {
        searchPaths: state.settings.gameMode.searchPaths,
    };
}
function mapDispatchToProps(dispatch) {
    return {
        onSetSearchPaths: (paths) => dispatch(setGameSearchPaths(paths)),
    };
}
function nop() {
    // nop
}
function PathsList(props) {
    const { t, onAddSearchPath, onSelectPath, onUpdateSearchPath, paths } = props;
    const remove = React.useCallback((evt) => {
        const remPath = evt.currentTarget.getAttribute("data-path");
        props.onRemoveSearchPath(remPath);
    }, [props.onRemoveSearchPath]);
    return (React.createElement("div", null,
        React.createElement(ListGroup, null,
            paths.map((iter, idx) => (React.createElement(ListGroupItem, { key: idx, className: "game-search-path" },
                React.createElement(PathInput, { t: t, value: iter, idx: idx, selectPath: onSelectPath, updatePath: onUpdateSearchPath }),
                React.createElement(IconButton, { className: "btn-embed pull-right", tooltip: t("Remove"), "data-path": iter, onClick: remove, icon: "remove" })))),
            React.createElement(ListGroupItem, null,
                React.createElement(Button, { onClick: onAddSearchPath },
                    React.createElement(Icon, { name: "add" }),
                    React.createElement("div", { className: "button-text" }, t("Add a search path")))))));
}
function PathInput(props) {
    const { t, value, idx } = props;
    const updatePath = React.useCallback((evt) => {
        props.updatePath(idx, evt.currentTarget.value);
    }, [props.updatePath, idx]);
    const selectPath = React.useCallback(async () => {
        const selectedPath = await props.selectPath(value);
        if (selectedPath !== undefined) {
            props.updatePath(idx, selectedPath);
        }
    }, [props.selectPath, props.updatePath]);
    return (React.createElement(InputGroup, null,
        React.createElement(FormControl, { type: "text", value: value, onChange: updatePath }),
        React.createElement(InputGroup.Button, { className: "inset-btn" },
            React.createElement(IconButton, { id: "change-tool-path", tooltip: t("Change"), onClick: selectPath, icon: "browse" }))));
}
export default withTranslation("default")(connect(mapStateToProps, mapDispatchToProps)(GameSelectionDialog));
